import { Route, Location } from 'vue-router';
import router from '@/router';
import { resolve } from '@/app/container';
import { AspectService, AspectServiceSymbol } from '@/app/aspect/aspect-service';

export const getCurrentPage = (): string => {
  return router.currentRoute.params.page;
};

export const handleBeforePageRouteEnter = async (to: Route, next: any): Promise<void> => {
  const aspectService: AspectService = resolve<AspectService>(AspectServiceSymbol);
  if ((to.name !== 'page' && to.name !== 'oldPage') || to.params.page) {
    const section = aspectService.calculateSectionByPage(to.params.page);
    if (section !== null) {
      await aspectService.calculateSelectedChapter(section.id);
    }
    next();
  } else {
    const firstPageId: string|null = aspectService.getFirstPageId();
    if (firstPageId !== null) {
      const section = aspectService.calculateSectionByPage(firstPageId);
      if (section !== null) {
        await aspectService.calculateSelectedChapter(section.id);
      }
      next(getPageLocationByHref(firstPageId));
    } else {
      next({ name: 'notFound' });
    }
  }
};

export const getPageLocationByHref = (href: string) => {
  const query: any = {};
  const items: string[] = href.split('#');
  if (items.length > 1) {
    query.section = items[1];
  }

  return {
    name: 'page',
    params: { page: items[0] },
    query
  };
};

export const getPageFromHref = (href: string) => {
  const items: string[] = href.split('#');
  if (items.length > 0) {
    return items[0];
  }

  return href;
};

export async function navigateToPage(page: string, sectionId: string, isChild: boolean) {
  const location = createPageLocation(page, sectionId, isChild)

  await router.push(location);
}

export function createPageLocation(page: string, sectionId: string, isChild: boolean) {
  const location: Location = getPageLocationByHref(page);

  if ((!location.query || !location.query.section) && isChild) {
    location.query = {
      section: sectionId
    };
  }

  return location
}
